import { Injectable } from "@angular/core";
import { db } from "../../../core/database/db";

@Injectable({
  providedIn: "root"
})
export class ZoneService {

  async getZonesByLotId(lotId: number) {
    return await db.zone.where("lotId").equals(lotId)
      .toArray();
  }
}